import React, {useEffect, useState} from "react";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import EventBus from "../../util/EventBus";
import {Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from "@mui/material";
import css_buttons from "../Common/css/CCButton.module.scss";
import CCButton from "../Common/CCButton";
import { Info } from "@mui/icons-material";
import * as validators from "../../util/Validators";
import {makeEnterpriseComponent, updateObject} from "../../util/utility";


export default function CopyMilestone(props: any) {
    const [projectPlanPhaseMilestoneEnterpriseComponent] = useState(() => makeEnterpriseComponent("ProjectPlanPhaseMilestone"));
    const [backgroundOperation, setBackgroundOperation] = useState<boolean>(false);
    const [controls, setControls] = useState<any>({"MilestoneToCopyNewName": {"value": ""}});

    function enterpriseComponentInsertStartedListener(ec: EnterpriseComponent) {
        setBackgroundOperation(true)
    }

    function enterpriseComponentInsertCompletedListener(ec: EnterpriseComponent) {
        EventBus.components.emit("project-plan-phase-milestone-copy-save");
    }

    useEffect(() => {
        projectPlanPhaseMilestoneEnterpriseComponent.addInsertStartedListener(enterpriseComponentInsertStartedListener);
        projectPlanPhaseMilestoneEnterpriseComponent.addInsertCompletedListener(enterpriseComponentInsertCompletedListener);

        return () => {
            projectPlanPhaseMilestoneEnterpriseComponent.addInsertStartedListener(enterpriseComponentInsertStartedListener);
            projectPlanPhaseMilestoneEnterpriseComponent.addInsertCompletedListener(enterpriseComponentInsertCompletedListener);
        }

    }, [projectPlanPhaseMilestoneEnterpriseComponent, props.enterpriseComponent]);

    function onCancelHandler() {
        EventBus.components.emit("project-plan-phase-milestone-copy-cancel");
    }

    function saveHandler() {
        projectPlanPhaseMilestoneEnterpriseComponent.newRecord();
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("MilestoneToCopyUSID", props.milestoneUSID);
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("MilestoneToCopyNewName", controls["MilestoneToCopyNewName"].value)
        projectPlanPhaseMilestoneEnterpriseComponent.executeInsert();
    }

    function milestoneToCopyNewNameChangedHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        let check = validators.NoSpecialCharacters(event.target.value);

        const updatedFormElement = updateObject(controls["MilestoneToCopyNewName"], {
            value: event.target.value,
            touched: true,
            valid: check,
            helperText: null,
        });
        const updatedForm = updateObject(controls, {
            "MilestoneToCopyNewName": updatedFormElement,
        });

        setControls(updatedForm);
    }

    function updateView() {
        let buttonHandler = null;
        let objectDetailContent = null;

        if (!backgroundOperation) {
            let firstButtonHandlerContent = (
                <CCButton
                    className={css_buttons.redStandardButton}
                    onClick={onCancelHandler}>
                    Cancel
                </CCButton>
            );

            let secondButtonHandlerContent = (
                <CCButton
                    disabled={controls["MilestoneToCopyNewName"].value.length === 0}
                    className={css_buttons.blueStandardButton}
                    animate={backgroundOperation}
                    onClick={() => saveHandler()}>
                    Save
                </CCButton>
            )

            buttonHandler = (
                <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                    {firstButtonHandlerContent}
                    {secondButtonHandlerContent}
                </DialogActions>
            );
        }

        return (
            <>
                <Dialog open={true} scroll="body">
                    <DialogTitle>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#000000"}}>Copy Milestone:&nbsp;&nbsp;</Typography>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#A8A9AF"}}>{props.milestoneName}</Typography>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <div style={{display: "flex", flexDirection: "row", margin: "20px 20px 20px 0"}}>
                                <div>
                                    <Info sx={{marginTop: "5px", width: "60px", height: "60px", color: "#F1C40F"}}/>
                                </div>
                                <div>
                                    <Typography style={{margin: "13px 0 0 6px", fontSize: "16px", fontWeight: 400, color: "#000000"}}>Please provide a Name for the new milestone.</Typography>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", margin: "0 20px 20px 0", width: "100%"}}>
                                <TextField
                                    key="Name"
                                    margin="dense"
                                    fullWidth={true}
                                    helperText={"A value is required."}
                                    id="Name"
                                    label="Name *"
                                    onChange={(event) => milestoneToCopyNewNameChangedHandler(event)}
                                    value={controls["MilestoneToCopyNewName"].value}
                                    variant="outlined"
                                    slotProps={{
                                        input: {
                                        },
                                        inputLabel: {shrink: true}
                                    }}
                                />
                            </div>
                        </div>
                        {objectDetailContent}
                    </DialogContent>
                    {buttonHandler}
                </Dialog>
            </>
        );
    }

    return (
        <>
            {updateView()}
        </>
    )
}
